export const contextKey = Symbol('carousel-context');

import type { ResponseSpacing, Spacing } from '@athena-lib/spacing';
import type { Snippet } from 'svelte';
import type { Action } from 'svelte/action';

export type CarouselProps = {
  itemCount: number;
  peekNext?: boolean;
  children: Snippet;
  class?: string;
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
  useButtons?: boolean;
  onChange?: (index: number) => void;
  onShowArtist?: (value: boolean) => void;
};

export type FullwidthCarouselProps = {
  children: Snippet;
  space?: Spacing | ResponseSpacing;
  class?: string;
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
};

export type CarouselItemProps = {
  children: Snippet;
  class?: string;
};

export type FullwidthCarouselItemProps = CarouselItemProps & {
  innerClass?: string;
};

export type CarouselContext = {
  peekNext: () => boolean;
};
